import { render } from 'preact/compat';
import { useState, useEffect } from 'preact/hooks';
import { MediaCard } from '@components/MediaCard/MediaCard';

type Props = {
  eventUrl: string;
  singleCluster: boolean;
  highlight: boolean;
};

type EventData = {
  url: string;
  title: string;
  image: {
    src: string;
    srcset: string;
  };
  badge: {
    day: string;
    month: string;
  };
  datetime: string;
  location: string;
  excerpt: string;
};

async function fetchEventData(articleDescription: string) {
  try {
    const response = await fetch(articleDescription);
    if (!response.ok) {
      throw new Error('Failed to fetch event data');
    }
    const data = await response.json();

    return {
      url: data.url,
      title: data.title,
      image: {
        src: data.image.src,
        srcset: data.image.srcset,
      },
      badge: {
        day: data.badge.day,
        month: data.badge.month,
      },
      datetime: data.datetime,
      location: data.location,
      excerpt: data.excerpt,
    };
  } catch (error) {
    console.error('Error fetching event data:', error);
    return null;
  }
}

export const BentoBox = ({ eventUrl, singleCluster, highlight }: Props) => {
  const [eventData, setEventData] = useState<EventData | null>(null);

  useEffect(() => {
    const getEventData = async () => {
      if (eventUrl) {
        const data = await fetchEventData(eventUrl);
        setEventData(data);
      }
    };

    getEventData();
  }, []);

  return (
    <>
      {eventData && (
        <MediaCard
          title={eventData?.title}
          text={eventData?.excerpt}
          url={eventData?.url}
          image={eventData?.image.src}
          srcset={eventData?.image.srcset}
          badge={eventData?.badge}
          datetime={eventData?.datetime}
          location={eventData?.location}
          isSingleDemo={singleCluster}
          isHighlight={highlight}
          mediaType="event"
          isTest={false}
        />
      )}
    </>
  );
};

document.querySelectorAll('.pts-bento-box-card').forEach(bentoBoxCard => {
  const clusterDescription = bentoBoxCard.getAttribute('cluster-description');
  const qtt = bentoBoxCard.getAttribute('qtt');
  const singleCluster = qtt === '1';
  const eventUrl = `${clusterDescription}.json`;

  render(
    <BentoBox
      eventUrl={eventUrl || ''}
      singleCluster={singleCluster}
      highlight={singleCluster}
    />,
    bentoBoxCard,
  );
});
